import { ASPECT_RATIOS, QUALITY_OPTIONS } from './constants';

const SIZE_TO_ASPECT_RATIO: Record<string, string> = {
  '1024x1024': '1:1',
  '2048x2048': '1:1',
  '2880x2880': '1:1',
  '3840x3840': '1:1',
  '1536x1024': '3:2',
  '2048x1360': '3:2',
  '3520x2336': '3:2',
  '1024x1536': '2:3',
  '1360x2048': '2:3',
  '2336x3520': '2:3',
  '1024x768': '4:3',
  '2048x1536': '4:3',
  '3312x2480': '4:3',
  '768x1024': '3:4',
  '1536x2048': '3:4',
  '2480x3312': '3:4',
  '1280x1024': '5:4',
  '2560x2048': '5:4',
  '3216x2576': '5:4',
  '1024x1280': '4:5',
  '2048x2560': '4:5',
  '2576x3216': '4:5',
  '1536x864': '16:9',
  '2048x1152': '16:9',
  '3840x2160': '16:9',
  '864x1536': '9:16',
  '1152x2048': '9:16',
  '2160x3840': '9:16',
  '2048x1024': '2:1',
  '2688x1344': '2:1',
  '3840x1920': '2:1',
  '1024x2048': '1:2',
  '1344x2688': '1:2',
  '1920x3840': '1:2',
  '1881x836': '3:1',
  '3072x1024': '3:1',
  '3840x1280': '3:1',
  '887x1774': '1:3',
  '1024x3072': '1:3',
  '1280x3840': '1:3',
  '2016x864': '21:9',
  '2688x1152': '21:9',
  '3840x1648': '21:9',
  '864x2016': '9:21',
  '1152x2688': '9:21',
  '1648x3840': '9:21',
};

const LEGACY_ASPECT_RATIO_ALIASES: Record<string, string> = {
  '16:9-4k': '16:9',
  '9:16-4k': '9:16',
  '1:1-4k': '1:1',
};

function normalizeSizeLikeValue(value?: string): string {
  return (value || '').trim().toLowerCase().replace(/[×✕]/g, 'x').replace(/\s+/g, '');
}

export function getApiSize(aspectRatioValue: string): string {
  const normalizedValue = normalizeSizeLikeValue(aspectRatioValue);
  const ratio = ASPECT_RATIOS.find((item) => item.value === normalizedValue);
  if (ratio) return ratio.apiValue;
  if (normalizedValue === 'auto' || /^\d+x\d+$/.test(normalizedValue)) return normalizedValue;
  return '1024x1024';
}

export function normalizeAspectRatioValue(value?: string): string {
  const normalizedValue = normalizeSizeLikeValue(value);
  if (!normalizedValue) return 'auto';
  if (LEGACY_ASPECT_RATIO_ALIASES[normalizedValue]) return LEGACY_ASPECT_RATIO_ALIASES[normalizedValue];
  if (ASPECT_RATIOS.some((item) => item.value === normalizedValue)) return normalizedValue;
  return SIZE_TO_ASPECT_RATIO[normalizedValue] || 'auto';
}

export function getApiQuality(qualityValue: string): string {
  const quality = QUALITY_OPTIONS.find(q => q.value === qualityValue);
  return quality?.apiValue || 'low';
}
